import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, FormFeedback, Input } from "reactstrap";
import axios from "axios";

import Form from "./../../../general/Form/Form";
import classes from '../../placeholderTrucks/EditPlaceholderModal/EditPlaceholderModal.module.scss'
import { boxiRed } from "../../../../assets/style/colors";
import ImageCropModal from "../ImageCropModal/ImageCropModal";

class EditUserModal extends Component {
  state = {
    invalidEmail: false,
    userProfileUrlModal: '',
    invalidPictureModal: false,
    imageUploadLoadingModal: false,
    disableSaveButton: false
  };

  componentDidMount(){
    this.setState({
      invalidEmail: false,
      userProfileUrlModal: '',
      invalidPictureModal: false,
      imageUploadLoadingModal: false,
      disableSaveButton: false
    })
  }


  componentDidUpdate(prevProps) {
    const { data } = this.props;
    const prevUserProfileUrl = prevProps?.data?.userProfileUrl;
    const currentUserProfileUrl = data?.userProfileUrl;
  
    if (currentUserProfileUrl !== prevUserProfileUrl) {
      this.setState({
        userProfileUrlModal: currentUserProfileUrl && currentUserProfileUrl !== "null" ? currentUserProfileUrl : ''
      });
    }
  }

  disableTheButton = (value) => {
    this.setState({
      disableSaveButton: value
    })
  }

  onFormSubmitHandler = () => {
    let state = {
      invalidEmail: false
    };
    this.setState(state);

    let email = this.emailRef.value;

    if(this.state.userProfileUrlModal === ''){
      this.setState({
        invalidPictureModal: true,
      })
      return;
    }
    if (email) {
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      };
      const data = {
        name: this.nameRef.value,
        email: email,
        company: this.companyRef.value,
        privilege_id: 4,
        password: '',
        userProfileUrl: this.state.userProfileUrlModal.length > 0 ? this.state.userProfileUrlModal: null
      };
      let userId = this.props.data.user_id;

      axios.put(`${process.env.REACT_APP_API_HOST}/user/${userId}`, data, config).then((response) => {
        if (response.status === 200 && response.data.updated_user.length > 0) {
          alert(`The account for ${data.name} was updated`);
          window.location.reload();
        }
      });
    }

    if (!email) state.invalidEmail = true;
    this.setState({
      ...state
    });
  };

  handleImageUpload = async (selectedImage) => {
    this.setState({
      imageUploadLoadingModal: true,
      invalidPictureModal: false
    })
    if (selectedImage) {
      try {
        const blob = new Blob([selectedImage], { type: selectedImage.type });
        const formData = new FormData();
        this.setState({
          disableSaveButton: true
        })
        formData.append("image", blob, selectedImage.name);
        const res = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_HOST}/user/upload-media`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (res?.data?.uploaded_image) {
          this.setState({
            userProfileUrlModal: res?.data?.uploaded_image,
            imageUploadLoadingModal: false,
            disableSaveButton: false
          })
        } else {
          this.setState({
            userProfileUrlModal: '',
            imageUploadLoadingModal: false,
            disableSaveButton: false
          })
        }
      } catch (error) {
        console.log(error);
        this.setState({
          userProfileUrlModal: '',
          imageUploadLoadingModal: false,
          disableSaveButton: false
        })
      }
    }


  };

  setInvalidProfileError = () => {
    this.setState({
      invalidPictureModal: false
    })
  }

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    let clientData = {
      name: null,
      email: null,
      company: null,
      image: null
    };
    if (this.props.data) {
      clientData.name = this.props.data.user_name;
      clientData.email = this.props.data.email;
      clientData.company = this.props.data.company;
    }

    return (
      <Modal isOpen={this.props.show} toggle={this.props.toggleModal}>
        <ModalHeader toggle={this.props.toggleModal}>Edit Client User</ModalHeader>
        <ModalBody>
          <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
          <FormGroup>
                <div className={classes.image_upload}>
                    {/* {!this.state.imageUploadLoadingModal && (!this.state.userProfileUrlModal ? ( */}
                      <ImageCropModal userProfileUrlModal={this.state.userProfileUrlModal} setInvalidProfileError={this.setInvalidProfileError} classes={classes} disableTheButton={this.disableTheButton} handleImageUpload={this.handleImageUpload}/>
                    {/* ) : (
                      <img
                        style={{
                          height: '100px',
                          width: '100px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                        src={this.state.userProfileUrlModal}
                        alt="client uploaded image"
                      />
                    ))} */}
                  {this.state.invalidPictureModal ? <p style={{color: boxiRed}}>Picture is required</p> : ''}
                </div>
              </FormGroup>
            <FormGroup>
              <Label for="clientName">Name</Label>
              <Input
                autoComplete="new-password"
                type="text"
                name="name"
                defaultValue={clientData.name}
                innerRef={(el) => (this.nameRef = el)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="clientEmail">Email</Label>
              <Input
                autoComplete="new-password"
                type="email"
                name="email"
                defaultValue={clientData.email}
                invalid={this.state.invalidEmail}
                innerRef={(el) => (this.emailRef = el)}
              />
              <FormFeedback>Client user must have an email.</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="clientCompany">Company</Label>
              <Input type="text" name="company" defaultValue={clientData.company} innerRef={(el) => (this.companyRef = el)} />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onFormSubmitHandler} disabled={this.state.disableSaveButton}>
            Save
          </Button>
          <Button color="secondary" onClick={() => {
            this.props.toggleModal()
            this.setState({
              userProfileUrlModal: '',
    invalidPictureModal: false,
    imageUploadLoadingModal: false
            })
            }}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditUserModal;
